'use client';

import { Box, Link } from '@coolblue-development/freddy';
import selectItemTrigger from '@coolblue-development/ga4-events/triggers/ComparisonTool/selectItemTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductCard as ProductCardComponent } from '@coolblue-development/next-patterns/client';
import { PromotionalProductImage } from '@coolblue-development/next-patterns/core';
import legacyPromotionalContentFactory from '@features/shared/PromotionalContent/legacyPromotionalContentFactory';
import { promotionalContentFactory } from '@features/shared/PromotionalContent/promotionalContentFactory';
import { type ReactElement } from 'react';

import type { Product } from '../../typings/types';

type ProductCardProps = {
  product: Product;
  cbcLabel?: ReactElement;
  index: number;
  total_indices: number;
  shouldUsePromotionalContent: boolean;
};

const ProductCard = ({
  product,
  cbcLabel,
  index,
  total_indices,
  shouldUsePromotionalContent
}: ProductCardProps) => {
  const { trackEvent } = useAnalytics();

  const analyticsProps = {
    index,
    total_indices,
    item_id: product.id
  };

  const legacyPromotionalContent = legacyPromotionalContentFactory(product.promoIcon, product.name);

  function trackItemSelection() {
    trackEvent(
      selectItemTrigger({
        ...analyticsProps,
        sub_feature: 'clicked_item',
        method: 'image'
      })
    );
  }

  return (
    <Box
      component='li'
      px={300}
      sx={{
        alignContent: 'start',
        width: 'var(--comparison-column-width)'
      }}
    >
      {/* Hotfix to hide the empty SalesPrice and ProductTitle slots and the gaps,
        we also pass an empty fragment for both slots */}
      <Box
        mt={50}
        sx={theme => ({
          '& > div > div:not(:first-child)': { display: 'none' },
          img: { maxWidth: `calc(var(--comparison-column-width) - ${theme.spacing[600]})` }
        })}
      >
        <ProductCardComponent.Generic
          promotionalProductImage={
            <Link href={product.urls.product} onClick={trackItemSelection}>
              <PromotionalProductImage
                alt={product.name}
                size='medium'
                imageId={product.primaryImage.id}
                loading={index > 1 ? 'lazy' : 'eager'}
                primaryLabel={cbcLabel ? cbcLabel : null}
                labelsPosition='middle'
                promotionalContent={
                  shouldUsePromotionalContent
                    ? promotionalContentFactory(product.promotionalContent)
                    : legacyPromotionalContent
                }
              />
            </Link>
          }
          productTitle={<></>}
          salesPrice={<></>}
        />
      </Box>
    </Box>
  );
};

export { ProductCard };
